'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function MagicStick(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement(
      'defs',
      null,
      React.createElement('style', { type: 'text/css' })
    ),
    React.createElement('path', { d: 'M216.128 258.976L314.24 176.704a32 32 0 0 1 45.056 3.936L811.84 719.936a32 32 0 0 1-3.936 45.088l-98.08 82.272a32 32 0 0 1-45.056-3.936L212.16 304.064a32 32 0 0 1 3.936-45.088z m189.088 175.552l287.968 343.168 49.024-41.12-288-343.2-48.992 41.152zM281.792 287.424l49.024-41.12 82.272 98.048-49.024 41.152-82.24-98.08zM160 480v-32h32v32h32v32H192v32H160v-32H128v-32h32z m544-288V96h64v96h96v64h-96v96h-64V256h-96V192h96zM256 672v-64h64v64h64v64h-64v64H256v-64H192v-64h64z', 'p-id': '2962' })
  );
}
MagicStick.displayName = 'MagicStick';

module.exports = MagicStick;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/magicStick.js
// module id = 185
// module chunks = 0